/**
 * Utility functions for text processing
 */

/**
 * Checks if the given text ends with sentence-ending punctuation
 * @param text - The text to check
 * @returns true if the text ends with sentence-ending punctuation, false otherwise
 */
export function isEndOfSentence(text: string): boolean {
  // Check if text ends with sentence-ending punctuation
  const trimmedText = text.trim();
  if (trimmedText.length === 0) return false;

  const lastChar = trimmedText[trimmedText.length - 1];
  return [".", "!", "?", ":", ";"].includes(lastChar);
}
